import { GsFormField, GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { PictureDisplayMode } from '../../../models';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { pictureDisplayModeSchemaFor } from './../basics/picture-display-mode.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the checkout component form.
 * Defines the fields to display for the form.
 */
export const CHECKOUT_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    {
      formControlName: 'hideVoucher',
      label: 'components.checkout.schema.hideVoucher.label',
      description: 'components.checkout.schema.hideVoucher.description',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'newForDays',
      label: 'components.checkout.schema.newForDays',
      type: 'number',
      default: 10,
      min: 1
    },
    {
      ...pictureDisplayModeSchemaFor('pictureDisplayMode'),
      // Cut keeps the previous hard-coded object-cover as default
      default: PictureDisplayMode.Cut
    } as GsFormField<never>,

    // Button settings (nested under 'buttons' property)
    {
      formControlName: 'buttons',
      label: 'components.checkout.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
